import { enableProdMode, ErrorHandler, Injectable, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MyHammerConfig } from './app/app.module';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ResponseHandlerInterceptor } from './@tpl-core/interceptors/response-handler-interceptor';
import { ClientErrorHandler } from './@tpl-core/interceptors/error-handler.service';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, BrowserModule, HammerModule, bootstrapApplication } from '@angular/platform-browser';
import { SnackBarService } from './@ksm-core/shared/components/snackbar/snack-bar.service';
import { TranslatePipe, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withHashLocation, provideRouter, Routes } from '@angular/router';
import { AuthGuard } from './@tpl-core/guards/auth/auth.guard';
import { UserDetailsResolverService } from './@tpl-auth/services/user-details-resolver.service';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseModule } from '@fuse/fuse.module';
import { fuseConfig } from 'app/fuse-config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppStoreModule } from 'app/store/store.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { HighchartsChartModule } from 'highcharts-angular';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from './app/app.component';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'ksm/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'apps',
        loadChildren: () => import("./app/main/apps/apps.module").then(m => m.AppsModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'auth',
        loadChildren: () => import("./@tpl-auth/tpl-auth.module").then(m => m.TplAuthModule)
    },
    {
        path: 'pages',
        loadChildren: () => import("./app/main/pages/pages.module").then(m => m.PagesModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'ui',
        loadChildren: () => import("./app/main/ui/ui.module").then(m => m.UIModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'documentation',
        loadChildren: () => import("./app/main/documentation/documentation.module").then(m => m.DocumentationModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'style-guide',
        loadChildren: () => import("./app/style-guide/style-guide.module").then(m => m.StyleGuideModule)
    },
    {
        path: 'ksm',
        data: {
            breadcrumb: 'Ksm'
        },
        loadChildren: () => import("./@ksm/ksm.module").then(m => m.KsmModule),
        canActivate: [AuthGuard],
        resolve: { currentUser: UserDetailsResolverService }
    },
    { path: '**',
        redirectTo: 'ksm/dashboard?customerName=All' }
];


if ( environment.production )
{
    enableProdMode();
}
bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, CommonModule, HammerModule, TranslateModule.forRoot(), InMemoryWebApiModule.forRoot(FakeDbService, {
            delay: 0,
            passThruUnknownUrl: true
        }), 
        // Material moment date module
        MatMomentDateModule, 
        // Material
        MatButtonModule, MatIconModule, 
        // Fuse modules
        FuseModule.forRoot(fuseConfig), 
        // App modules
        LayoutModule, AppStoreModule, MatProgressSpinnerModule, MatFormFieldModule, MatSelectModule, HighchartsChartModule, FormsModule, MatSnackBarModule, MatDialogModule),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseHandlerInterceptor,
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: ClientErrorHandler
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig,
        },
        SnackBarService,
        TranslatePipe,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideRouter(appRoutes, withHashLocation())
    ]
})
                        .catch(err => console.error(err));
